sessionStorage.setItem("lo-back-to", window.location.href); // for use in the cart
$(document).ready(function () {
    // gift card and regular PDP are too different to share the rest of this file
    if (
        $("body").attr("id") == "digital-gift-card" ||
        $("body").attr("id") == "gift-card"
    ) {
        return;
    }

    if ($('body').hasClass('product-recurate')) return;

    const $variantInput = $("#variant-selector");
    const $variantButtons = $(".variants");
    const $swatches = $(".swatch-input");
    const $selectedColor = $("#selected-color");
    const $soldOutMsg = $("#sold-out-message");
    const $addToCartRow = $("#add-to-cart");
    const $addToWaitlistBtn = $("#waitlist-open");

    // helper to set a new active item
    function setActiveElement($elGroup, $el, className) {
        $elGroup.removeClass(className);
        $el.addClass(className);
    }

    // helper for money formatting
    function stripCents(str) {
        return str.replace(".00", "");
    }

    // fetch current state values
    function getActiveProductId() {
        return $(".swatch-input:checked").attr("id").replace("v-", "");
    }

    function getActiveVariantId() {
        return Number($variantInput.val());
    }

    function getActiveVariantData() {
        var variants = getProductVariants(getActiveProductId());
        var activeVariant = getActiveVariantId();
        for (var i = 0; i < variants.length; i++) {
            if (variants[i].id === activeVariant) {
                return variants[i];
            }
        }
    }

    // fetch any value
    function getProduct(id) {
        return siblingsJson[id];
    }

    function getProductVariants(id) {
        var product = getProduct(id);
        return product.variants;
    }

    // update values
    var setVariantInputValue = function (id) {
        // the hidden select
        $variantInput.val(id);
        // shopify also adds this hidden field
        // there was an edge case bug where switching variants and adding to cart would fail silently
        // updating this input seems to have fixed it 
        $('input[name="product-id"]').val(getActiveProductId());
    };
    var updateVariants = function () {
        // clear the old options
        $variantInput.html("");
        if ($variantButtons.length) {
            $variantButtons.find(".radio-input-group").remove();
        }
        // build the new options
        var variants = getProductVariants(getActiveProductId());
        variants.forEach((variant, index) => {
            let available = variant.available;
            if (
                window.variantStockData[variant.id].oosPolicy == "Sold Out" &&
                window.variantStockData[variant.id].oosThreshold >=
                window.variantStockData[variant.id].stockLevel
            ) {
                available = false;
            }
            let availableClass = available ? "" : "unavailable";
            $variantInput.append(
                `<option value="${variant.id}">${variant.title}</option>`
            );
            $variantButtons.append(
                `<div class="radio-input-group">
              <input type="radio" name="size" id="size-${index}" value="${variant.id}" aria-label="${variant.title} ${availableClass}">
              <label class="btn btn-secondary ${availableClass}" for="size-${index}">${variant.title}</label>
            </div>`
            );

            setVariantInputValue(variant.id);
        });

        // select the previously selected size/option
        $variantButtons.find(".btn").each(function () {
            if ($(this).text() === window.selectedVariantText) {
                let $radio = $(`#${$(this).attr("for")}`);
                $radio.prop("checked", true);
                setVariantInputValue($radio.val());
            }
        });
    };

    function updatePrice() {
        var $compareEl = $("#compare-price");
        var $priceEl = $("#price");
        var $discountEl = $("#price-wrapper .discount-label");
        var $discountValue = $("#price-wrapper .discount-amount");
        var $promoPrice = $("#price-wrapper .promo-price");
        var $promoMessage = $(".promo-message");
        var variant = getActiveVariantData();

        var price = variant.price;
        var comparePrice = variant.compare_at_price;

        if ($("#ab-enabled").hasClass("active")) {
            if ($("#ab-version").hasClass("v1")) {
                comparePrice = price / 0.7;
            }
            if ($("#ab-version").hasClass("v2")) {
                comparePrice = price / 0.8;
            }
            if ($("#ab-version").hasClass("v3")) {
                comparePrice = price;
            }
        }

        var discountAmount = Math.round(
            (100 * (comparePrice - price)) / comparePrice
        );
        var promoMessage = variantPromo[variant.id].promoMessage;

        var formattedCompare = stripCents(
            LS.Currency.formatMoney(comparePrice, theme.moneyFormat)
        );
        var formattedPrice = stripCents(
            LS.Currency.formatMoney(price, theme.moneyFormat)
        );

        if (comparePrice > 0 && price !== comparePrice) {
            $priceEl.html(formattedPrice);
            $compareEl.html(formattedCompare).show();
            $discountValue.text(discountAmount);
            $discountEl.show();
        } else {
            $promoPrice.hide();
            $discountEl.hide();
            $compareEl.hide();
            $priceEl.html(formattedPrice);
        }
        if (promoMessage.length > 0) {
            $promoPrice.text(promoMessage).show();
        } else {
            $promoPrice.hide();
        }

        // always hide the promo message when we're display the MSRP at full price
        if ($("#ab-enabled").hasClass("active")) {
            if ($("#ab-version").hasClass("v3")) {
                $promoPrice.hide();
            }
        }

        $(".shop-pay-price").text(
            stripCents(LS.Currency.formatMoney(price / 4, theme.moneyFormat))
        );
        // stash pricing info in order data
        var discount = comparePrice > 0 ? (1 - price / comparePrice).toFixed(2) : 0;
        var fullPrice = comparePrice > 0 ? comparePrice : price;
        var salePrice = comparePrice > 0 ? (price / 100).toFixed(2) : 0;
        $("#itemprop-full-price").val((fullPrice / 100).toFixed(2));
        $("#itemprop-sale-price").val(salePrice);
        $("#itemprop-discount").val(discount);
    }

    /*
      Duplicate of object elevar generates
    */
    function getCurrentProductData() {
        var productId = getActiveProductId();
        var product = getProduct(productId);
        var variant = getActiveVariantData();
        return {
            currencyCode: window.theme.currencyCode,
            products: [
                {
                    id: variant.sku,
                    name: product.title,
                    brand: product.vendor,
                    category: product.type,
                    variant: variant.title,
                    price: JSON.stringify(variant.price * 0.01),
                    product_id: productId,
                    variant_id: JSON.stringify(variant.id),
                    compare_at_price: variant.compare_at_price * 0.01,
                    image: siblingsSupplimentalJson[productId].featuredImage
                },
            ],
        };
    }

    function updateMessageBadge() {
        let productId = getActiveProductId();
        let $container = $('#pdp-message-badge-container');
        let obj = window.siblingsSupplimentalJson[productId].messageBadge;
        $container.html('');
        if (!obj.text) return;
        let styleAttr = obj.style === 'Icon' ? `style="background-image: url(${obj.icon})"` : '';
        $container.html(`<div class="pdp-message-badge is-style-${obj.style}" ${styleAttr}>${obj.text}</div>`);
    }

    function triggerProductView() {
        var productData = getCurrentProductData();
        // push product change to swym to update wishlist button
        let data = {
            empi: +productData.products[0].product_id,
            epi: productData.products[0].variant_id,
            du: window.location.href,
        };
        document.dispatchEvent(
            new CustomEvent("swym:variant-change", { detail: data })
        );
        window.ElevarDataLayer.push({
            'event': 'dl_view_item',
            'ecommerce': {
                'currencyCode': productData.currencyCode,
                'detail': {
                    'products': productData.products
                }
            }
        })
    }

    /*
    * Make an image item for the media gallery
    */
    function makeImageItem(element, index) {
        const li = document.createElement('li');
        const button = document.createElement('button');
        const img = document.createElement('img');
        const span = document.createElement('span');
        let loading = index < 4 ? 'eager' : 'lazy';

        img.setAttribute('src', element.src);
        img.setAttribute('width', 300);
        img.setAttribute('height', 300);
        img.setAttribute('alt', element.alt);
        img.setAttribute('loading', loading);

        span.className = "item-badge";
        if (element.organic && index === 0) {
            span.innerHTML = window.organicTag;
        }
        if (element.upcycled && index === 0) {
            span.innerHTML = window.upcycledTag;
        }

        button.className = 'item sibling-item zoomable active';
        button.dataset.galleryId = getActiveProductId();
        button.dataset.href = element.href;
        button.dataset.index = index;

        button.append(img);
        button.append(span);
        li.append(button);

        return li;
    }

    /*
   * Make a thumbnail item
   */
    function makeThumbItem(element, index) {
        const li = document.createElement('li');
        const button = document.createElement('button');
        const img = document.createElement('img');

        img.setAttribute('src', element.thumb ? element.thumb : element.poster);
        img.setAttribute('width', 80);
        img.setAttribute('height', 80);
        img.setAttribute('alt', `navigate to gallery index ${index}`);
        if (index < 4) {
            img.setAttribute('loading', 'eager');
        } else {
            img.setAttribute('loading', 'lazy');
        }

        button.className = 'thumb-item';
        button.dataset.galleryId = getActiveProductId();
        button.dataset.index = index;

        button.append(img);
        li.append(button);

        if (index === 0) {
            li.classList.add('current-thumbnail');
        }

        return li;
    }

    /*
    * Get the source for a video, which sometimes is an array of sources when hosted by shopify
    */
    function getSrc(element) {
        if (typeof element.src === 'string') {
            return element.src;
        }
        let srcObj = element.src.find((obj) => { return obj.type === 'video/mp4' });
        if (!srcObj) {
            return null
        }
        return srcObj.url;
    }

    /*
    * Make an video item for the media gallery
    */
    function makeVideoItem(element, index) {
        let src = getSrc(element);
        if (!src) {
            return;
        }

        const li = document.createElement('li');
        const div = document.createElement('div');
        const video = document.createElement('video');
        const source = document.createElement('source');

        div.className = 'item active';

        video.id = `gallery-sibling-video-${index}`;
        video.setAttribute('width', '100%');
        video.setAttribute('poster', element.poster);
        video.setAttribute('playsinline', true);
        video.setAttribute('controls', true);

        source.setAttribute('type', 'video/mp4');
        source.setAttribute('src', src);

        li.className = "internal";

        video.append(source);
        div.append(video);
        li.append(div);

        return li;
    }

    /*
    * Make a video thumbnail item
    */
    function makeVideoThumbItem(element, index) {
        let li = makeThumbItem(element, index);
        li.classList.add('is-type-video');
        return li;
    }

    function loadGallery() {
        // make things easier to read below
        let siblingImages = window.mediaGalleryConfig.siblingImages[getActiveProductId()];
        let siblingVideos = window.mediaGalleryConfig.siblingVideos[getActiveProductId()];
        let lifestyleImages = window.mediaGalleryConfig.lifestyleImages;
        let videos = window.mediaGalleryConfig.videos;

        // clear everything except the loader
        let $gallery = $(".pdp-gallery");
        if ($gallery.hasClass('slick-initialized')) {
            $gallery.slick('unslick');
        }
        $gallery.addClass('working').html('');

        let $thumbs = $(".pdp-thumbnails");
        if ($thumbs.hasClass('slick-initialized')) {
            $thumbs.slick('unslick');
        }
        $thumbs.addClass('working').html('');

        let totalIndex = 0;

        // inject this product's images
        for (let index = 0; index < siblingImages.length; index++) {
            $gallery.append(makeImageItem(siblingImages[index], totalIndex));
            $thumbs.append(makeThumbItem(siblingImages[index], totalIndex));
            totalIndex++;
        }

        // inject product videos
        for (let index = 0; index < siblingVideos.length; index++) {
            $gallery.append(makeVideoItem(siblingVideos[index], totalIndex));
            $thumbs.append(makeVideoThumbItem(siblingVideos[index], totalIndex));
            totalIndex++;
        }

        // inject common lifestyle images
        for (let index = 0; index < lifestyleImages.length; index++) {
            $gallery.append(makeImageItem(lifestyleImages[index], totalIndex));
            $thumbs.append(makeThumbItem(lifestyleImages[index], totalIndex));
            totalIndex++;
        }

        // inject common videos
        for (let index = 0; index < videos.length; index++) {
            $gallery.append(makeVideoItem(videos[index], totalIndex));
            $thumbs.append(makeVideoThumbItem(videos[index], totalIndex));
            totalIndex++;
        }

        const NEXT_BUTTON = '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.637701 22.2029L10.2754 11.6015L0.637701 1.00003" stroke="#111111" stroke-width="1.5"/> </svg> </button>';
        const PREV_BUTTON = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6377 22.203L2 11.6015L11.6377 1.00009" stroke="#111111" stroke-width="1.5"/> </svg> </button>';

        // all done
        $gallery.imagesLoaded(function () {
            const galleryHeight = $gallery.outerHeight();
            $gallery.removeClass("working");
            $thumbs.removeClass("working");
            if ($(window).width() < LS.desktopBreakpoint) {
                return;
            }
            $gallery.on('beforeChange', function (event, slick, current, index) {
                setActiveThumb(index);
                keepActiveThumbVisible(index, getVisibleThumbs(galleryHeight), $thumbs);
            });
            $gallery.slick({
                prevArrow: PREV_BUTTON,
                nextArrow: NEXT_BUTTON,
            });
            $thumbs.slick({
                slidesToShow: getVisibleThumbs(galleryHeight),
                slidesToScroll: getVisibleThumbs(galleryHeight),
                vertical: true,
                prevArrow: PREV_BUTTON,
                nextArrow: NEXT_BUTTON,
            });

        });
    };

    function setActiveThumb(index) {
        $('.pdp-thumbnails .slick-slide').removeClass('current-thumbnail');
        $(`.pdp-thumbnails [data-slick-index="${index}"`).addClass('current-thumbnail');
    }

    function keepActiveThumbVisible(index, visibleThumbs, $slider) {
        // where does the current big image fall within each set/page of thumbs
        let currentPage = Math.floor(index / visibleThumbs);
        // when multiple thumbs are shown, the current slide is the index of the first thumb in the set
        // so if our big image falls on a different page, go to the first thumb of that page to advance the whole set
        if ($slider.slick('slickCurrentSlide') !== currentPage) {
            $slider.slick('slickGoTo', currentPage * visibleThumbs);
        }
    }

    function getVisibleThumbs(galleryHeight) {
        const thumbHeight = 90; // 80 + 10px gap
        return Math.floor(galleryHeight / thumbHeight);
    };

    $('body').on('click', '.thumb-item', function () {
        $('.pdp-gallery').slick('slickGoTo', $(this).data('index'));
        setActiveThumb($(this).data('index'));
    });

    function updateUrl() {
        const url =
            $(".swatch-input:checked + .swatch").data("url") +
            "?variant=" +
            $variantInput.val();
        if (history.replaceState) {
            const newurl =
                window.location.protocol + "//" + window.location.host + url;
            window.history.replaceState({ path: newurl }, "", newurl);
            sessionStorage.setItem("lo-back-to", newurl); // for use in the cart
        }
        initVideowise();
    }

    function updateWaitlistMeta() {
        var productId = getActiveProductId();
        var variantId = getActiveVariantId();
        var product = getProduct(productId);

        $("#wl-image-src").val(product.featured_image);
        $("#wl-product").val(productId);
        $("#wl-variant").val(variantId);

        var swatch = $selectedColor.text();
        var size = "";
        if ($variantButtons.length) {
            size = "- " + $(".variants .selected").text();
        }
        $("[data-wl-meta]").text(`${swatch} ${size}`);
    }

    function updateCta(variantId) {
        var variant = getActiveVariantData(variantId);
        var stockData = variantStockData[variantId];
        var isAvailable = variant.available;
        var $addToCartBtn = $("#add-to-cart-btn");

        // reset to normal
        $addToCartBtn.text(window.addToCartBtnText);
        $addToCartRow.show();
        $soldOutMsg.hide();
        $addToWaitlistBtn.hide();

        // shopify says the product is available, but we say no
        if (stockData.oosSettings === "Unavailable") {
            isAvailable = false;
        }

        // make a product with some stock left behave as out of stock
        if (stockData.oosThreshold >= stockData.stockLevel) {
            isAvailable = false;
        }

        // shopify says the product is unavailable, but we say yes
        if (stockData.oosSettings === "Available") {
            isAvailable = true;
        }

        // this product can be sold, bail
        if (isAvailable) {
            return;
        }

        // Unavailable and won't be later, show sold out
        if (
            stockData.oosPolicy === "Sold Out" ||
            stockData.oosSettings === "Unavailable"
        ) {
            $addToCartRow.hide();
            $soldOutMsg.show();
            return;
        }

        // Pre-order items are unavailable today
        if (stockData.oosPolicy === "Pre-Order") {
            $addToCartBtn.text(window.preorderBtnText);
            return;
        }

        // Unavailable but will be later
        $addToWaitlistBtn.data("variant-id", variantId).show();
        $addToCartRow.hide();

        $("#wl-variant").val(variantId);
    }

    function updateLowStockWarning(variantId) {
        const inventoryLevel = variantStockData[variantId].stockLevel;
        const $warning = $("#stock-message");
        const lowStockThreshold = variantStockData[variantId].lowStockThreshold;
        const oosThreshold = variantStockData[variantId].oosThreshold;
        if (
            inventoryLevel > oosThreshold &&
            inventoryLevel <= lowStockThreshold
        ) {
            $warning.show();
        } else {
            $warning.hide();
        }
    }

    function updateFinalSaleMessage(variantId) {
        const $warning = $("#final-sale-message");
        const $field = $("#itemprop-final-sale");
        let finalSaleValue = variantStockData[variantId].finalSale;
        $field.val("");
        if (finalSaleValue.toLowerCase() === "true") {
            $warning.show();
            $field.val(1);
        } else {
            $warning.hide();
        }
    }

    function updateDeliveryMessage(variantId) {
        const $warning = $("#delivery-message");
        const $field = $("#itemprop-delivery");
        let msg = variantStockData[variantId].deliveryMessage;
        $warning.hide();
        $field.val("");
        if (msg) {
            $warning.text(msg).show();
            $field.val($warning.text());
        }
    }

    // visual changes when variants change
    function updateUi() {
        var variantId = getActiveVariantId();
        updateLowStockWarning(variantId);
        updateFinalSaleMessage(variantId);
        updateDeliveryMessage(variantId);
        updateCta(variantId);
        updateWaitlistMeta();
        updateMessageBadge();
        // delay for optimize to finish
        setTimeout(function () {
            updatePrice();
        }, 100);
    }

    // doing this on page load so we don't duplicate logic in the template
    updateUi();
    loadGallery();

    // swatches may not be marked as unavailable by shopify
    for (const [parentId, productObj] of Object.entries(window.siblingsJson)) {
        let $swatch = $(`.swatch[for="v-${parentId}"]`);
        let unavailableVariants = 0;
        // count variants with a Sold Out policy that are at or below the threshold where they'd be shown as sold out
        productObj.variants.forEach((v) => {
            if (
                variantStockData[v.id].oosPolicy == "Sold Out" &&
                variantStockData[v.id].oosThreshold >=
                variantStockData[v.id].stockLevel
            ) {
                unavailableVariants++;
                let $input = $(`[value="${v.id}"]`);
                // size input may not be shown for this variant as we loop through all of them
                if ($input.length) {
                    $input.attr(
                        "aria-label",
                        $input.attr("aria-label") + " unavailable"
                    );
                    $input.next(".btn").addClass("unavailable");
                }
            }
        });
        // if all variants are below their threshold, mark the swatch unavilable
        if (unavailableVariants.length == productObj.variants.length) {
            $swatch.addClass("unavailable");
        }

        // count variants with 0 inventory but should be shown as Waitlist
        // let waitlistVariants = productObj.variants.filter((v) => {
        // 	return variantStockData[v.id].oosPolicy == "Waitlist";
        // });
        // // if the template has marked the swatch as unavailable due to 0 stock on all variants,
        // // but we find at least one variant with a waitlist policy, show the swatch as available
        // if (waitlistVariants.length) {
        // 	$swatch.removeClass("unavailable");
        // }
    }

    /*
        Default add to cart watcher is disabled on elevar's side (not compatible with product switching) so we need to push the event to their dataLayer
    */
    $(".shopify-product-form").on("submit", function (e) {
        var productData = getCurrentProductData();
        window.ElevarDataLayer.push({
            'event': 'dl_add_to_cart',
            'ecommerce': {
                'currencyCode': productData.currencyCode,
                'add': {
                    'products': productData.products
                }
            }
        })
    });

    // changing colors, which also changes the entire product
    $swatches.on("change", function (e) {
        // stash the currently selected size for use when we rebuild the variants
        if ($variantButtons.length) {
            window.selectedVariantText = $(
                ".variants input:checked + .btn"
            ).text();
        }
        // update the active color
        $selectedColor.text($(this).next(".swatch").find("img").attr("alt"));
        // rebuild variant buttons and the hidden select element
        updateVariants();
        // show the color's images
        loadGallery();
        // switch to this color's PDP, also triggers GTM
        updateUrl();
        // rebuild
        updateUi();
        triggerProductView();
        updateWaitlistMeta();
    });

    // changing sizes, product remains the same
    if ($variantButtons.length) {
        $("body").on("change", ".variants input", function (e) {
            if ($(this).prop("checked")) {
                // e.preventDefault();
                // let $selectedSize = $(this);
                // // show variant as selected
                // setActiveElement($('.variants .btn'), $selectedSize, 'selected');
                // set the hidden select element to the new value
                setVariantInputValue($(this).val());
                // rebuild
                updateUi();
                updateUrl();
                triggerProductView();
                updateWaitlistMeta();
            }
        });
    }

    /*
    Modals
    */
    $(".pdp-modal-trigger").on("click", function (e) {
        e.preventDefault();
        $($(this).attr("href")).addClass("active");
    });
    $(".pdp-modal .panel-close").on("click", function (e) {
        e.preventDefault();
        $(this).closest(".pdp-modal").removeClass("active");
    });

    $(".size-fit-slider .slides").slick({
        dots: false,
        arrows: true,
    });

    let activeGallery = null;

    function setupSlides(gallery) {
        let index = gallery.getCurrentIndex();
        index++;
        gallery.currItem.container.ariaLabel =
            "slide " + index + " of " + gallery.options.getNumItemsFn();
        setTimeout(function () {
            $("#pswp-image-carousel .pswp__zoom-wrap").each(function () {
                $(this)
                    .attr("aria-hidden", true)
                    .attr("tabindex", -1)
                    .attr("role", "group");
            });
            gallery.currItem.container.ariaHidden = false;
            gallery.currItem.container.removeAttribute("tabindex");
        }, 500); // this is a little arbitrary, but we need to wait for the wrap elements to be available
    }

    $("body").on("click", ".zoomable", function (e) {
        e.preventDefault();
        window.returnFocusTo = $(this);
        let pswpElement = $(".pswp")[0];
        let items = pswpData[$(this).data("gallery-id")];
        let startIndex = $(this).data("index");
        var options = {
            showHideOpacity: true,
            showAnimationDuration: 500,
            loop: true,
            history: false,
            closeOnVerticalDrag: false,
            allowPanToNext: false,
            pinchToClose: false,
            closeEl: true,
            captionEl: false,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            counterEl: false,
            arrowEl: false,
            preloaderEl: false,
            tapToToggleControls: false,
            index: startIndex,
            errorMsg: '<p class="pswp__error-msg">Error Message..</p>',
            getDoubleTapZoom(e, t) {
                return 1;
            },
        };
        var gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );
        gallery.init();
        setupSlides(gallery);
        gallery.listen("beforeChange", function () {
            setupSlides(gallery);
            $("#pdp-link-to-full").attr("href", gallery.currItem.src); // link to the full image of the current item
        });
        gallery.listen("close", function () {
            LS.returnFocus();
        });
        $("#pdp-link-to-full").attr("href", $(this).data("href")); // link to the full image of the item clicked
        LS.trapFocus("#zoomed-gallery", false);
        activeGallery = gallery;
    });

    $("#zoomed-gallery .panel-close").on("click", function (e) {
        e.preventDefault();
        activeGallery.close();
    });
    $("#zoomed-gallery .prev").on("click", function (e) {
        e.preventDefault();
        activeGallery.prev();
        if ($(window).width() >= LS.desktopBreakpoint) {
            $('.pdp-gallery').slick('slickPrev');
        }
    });
    $("#zoomed-gallery .next").on("click", function (e) {
        e.preventDefault();
        activeGallery.next();
        if ($(window).width() >= LS.desktopBreakpoint) {
            $('.pdp-gallery').slick('slickNext');
        }
    });

    $("#payments-modal-trigger").on("click", function (e) {
        e.preventDefault();
        window.returnFocusTo = $(this);
        $("#shop-pay-modal-cover").addClass("shown").focus();
        LS.trapFocus("#shop-pay-modal-cover", false);
    });

    $("#shop-pay-modal-cover .btn__close").on("click", function (e) {
        e.preventDefault();
        $("#shop-pay-modal-cover").removeClass("shown");
        LS.returnFocus();
    });

    $("body").on("keyup", function (e) {
        if (LS.isEscape(e)) {
            $("#shop-pay-modal-cover").removeClass("shown");
            LS.returnFocus();
        }
    });
});
